var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{attrs:{"id":_vm.customButtonId,"variant":"outline-primary"},on:{"click":function($event){return _vm.getLink(_vm.research_id)}}},[(_vm.isBusyLink)?_c('b-spinner',{attrs:{"label":"Загружается...","small":""}}):_vm._e(),_vm._v(" Исследование ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }